export default __webpack_public_path__ + "static/media/fish.0ea6413a.png";